module.exports = __webpack_public_path__ + "static/media/ottawa.72755d69.png";